import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import { formatLatency } from './utils';
import { useStyles } from './styles';

const Card = ({ label, value, sub, color }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.summaryCard} elevation={1}>
      <div className={classes.summaryCardLabel}>{label}</div>
      <div className={classes.summaryCardValue} style={{ color }}>
        {value}
      </div>
      {sub && <div className={classes.summaryCardSub}>{sub}</div>}
    </Paper>
  );
};

const SummaryCards = ({ stats, loading }) => {
  const classes = useStyles();

  if (loading) {
    return (
      <Grid container spacing={2} className={classes.summaryCardGrid}>
        {[1, 2, 3, 4].map((i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Paper className={classes.summaryCard} elevation={1}>
              <CircularProgress size={24} />
            </Paper>
          </Grid>
        ))}
      </Grid>
    );
  }

  if (!stats) return null;

  const { totalCount, successCount, errorCount, avgLatencyMs } = stats;
  const successPct = totalCount > 0 ? ((successCount / totalCount) * 100).toFixed(1) : '0.0';
  const errorPct = totalCount > 0 ? ((errorCount / totalCount) * 100).toFixed(1) : '0.0';

  return (
    <Grid container spacing={2} className={classes.summaryCardGrid}>
      <Grid item xs={12} sm={6} md={3}>
        <Card label='Total Messages' value={totalCount} color='#173072' />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card
          label='Success'
          value={successCount}
          sub={`${successPct}% of total`}
          color='#45B116'
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card
          label='Errors'
          value={errorCount}
          sub={`${errorPct}% of total`}
          color={errorCount > 0 ? '#f44336' : '#757575'}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card label='Avg Latency' value={formatLatency(avgLatencyMs)} color='#2196f3' />
      </Grid>
    </Grid>
  );
};

export default SummaryCards;
